import { ParticipantType, Subject, Test, ParticipantsBase, TestRound } from '../models';
import { ChartData } from './Chart';

function getTestValue(
	testRound: TestRound,
	parallel: number,
	participantType: ParticipantType,
	samples: ParticipantsBase[],
	tests: Test[],
) {
	const targetTestId = tests.find((t) => t.test_name === testRound)?.test_id;
	const targetParticipant = targetTestId
		? samples.find((p) => p.test_id === targetTestId && p.parallel === parallel)
		: null;

	return targetParticipant
		? participantType === ParticipantType.Teacher
			? targetParticipant.involved_teachers_count
			: targetParticipant.tested_students_count
		: undefined;
}

export function getChartData(
	tests: Test[],
	samples: ParticipantsBase[],
	subject: Subject,
	participantType: ParticipantType,
): ChartData[] {
	const subjectTests = tests.filter((test) => test.subject === subject);
	const subjectTestIds = subjectTests.map((test) => test.test_id);
	const targetSamples = samples.filter((sample) => subjectTestIds.includes(sample.test_id));
	const parallels = targetSamples.map((p) => p.parallel);
	const uniqueParallels = Array.from(new Set(parallels));

	return uniqueParallels.sort().map((parallel) => ({
		parallel: parallel.toString(),
		firstTest: getTestValue(TestRound.First, parallel, participantType, targetSamples, subjectTests),
		secondTest: getTestValue(TestRound.Second, parallel, participantType, targetSamples, subjectTests),
		thirdTest: getTestValue(TestRound.Third, parallel, participantType, targetSamples, subjectTests),
	}));
}
